import { ApiMap } from '../ApiMap';
import { createApiCache } from './createApiCache';
const CtaCache = {};
const WebInteractiveCache = {};
export function getFetchCtaInfo(http) {
  const withCtaCache = createApiCache(http.get, ApiMap.CTAS.getUrl, CtaCache);
  return function fetchCtaInfo(guid) {
    const httpParams = {
      query: {
        includeCtaInfo: true
      }
    };
    return withCtaCache(guid, httpParams);
  };
}
export function getFetchWebInteractiveInfo(http) {
  const withWebInteractiveCache = createApiCache(http.post, ApiMap.WEB_INTERACTIVES.getUrl, WebInteractiveCache);
  return function fetchWebInteractiveInfo(contentId) {
    const httpParams = {
      data: {
        count: 1,
        objectTypeId: 'WEB_INTERACTIVE',
        requestOptions: {
          allPropertiesFetchMode: 'latest_version'
        },
        filterGroups: [{
          filters: [{
            property: 'hs_content_id',
            value: contentId,
            operator: 'EQ'
          }]
        }]
      }
    };
    return withWebInteractiveCache(undefined, httpParams, {
      cacheKey: contentId
    }).then(({
      results
    }) => {
      return results[0];
    });
  };
}